import {
  doc,
  getDoc,
  getDocs,
  updateDoc,
  query,
  where,
  deleteDoc,
  collection,
  // Timestamp,
  addDoc,
} from "firebase/firestore";
import { db, AlbumsRef, storage, AlbumShareRef, QuickTaleShareRef } from "../../../firebase";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";
import { getSingleUser } from "../../../modules/OrganizationQuickTales/hooks/QuickTalesHooks";

export const getAllAlbums = async (organizationId) => {
  try {
    return await getDocs(
      query(AlbumsRef, where("organization", "==", organizationId))
      // query(AlbumsRef, where("user", "==", organizationId))
    );
  } catch (error) {
    console.log("Error fetching data from Firestore:", error.message);
    // console.error("Error fetching data from Firestore:", error.message);
    return [];
  }
};
export const getSpecificUserAlbumShares = async (userId) => {
  try {
    return await getDocs(
      query(AlbumShareRef, where("sharedTo", "==", userId))
      // query(AlbumsRef, where("user", "==", organizationId))
    );
  } catch (error) {
    console.log("Error fetching data from Firestore:", error.message);
    // console.error("Error fetching data from Firestore:", error.message);
    return [];
  }
};

export const getSpecificUserQuicktaleShares = async (userId) => {
  try {
    return await getDocs(
      query(QuickTaleShareRef, where("sharedTo", "==", userId))
      // query(AlbumsRef, where("user", "==", organizationId))
    );
  } catch (error) {
    console.log("Error fetching data from Firestore:", error.message);
    // console.error("Error fetching data from Firestore:", error.message);
    return [];
  }
};

export const getQuicktalesSharedWithUser = async (userId) => {
  try {
    const sharedQTsSnap = await getSpecificUserQuicktaleShares(userId);
    return sharedQTsSnap;
  } catch (error) {
    console.error("Error getting shared quicktales:", error.message);
    throw error;
  }
};

export const getAlbumbyId = async (id) => {
  try {
    const response = await getDoc(doc(db, "albums", id));
    return response;
  } catch (error) {
    console.log("Error fetching data from Firestore:", error.message);
    return [];
  }
};

export const updateAlbum = async (id, album) => {
  console.log("SAVE DEBUG: updateAlbum called with id:", id);
  console.log("SAVE DEBUG: updateAlbum called with album data:", album);
  console.log("SAVE DEBUG: album.quicktales:", album.quicktales);
  
  const albumDocRef = doc(db, "albums", id);
  const result = await updateDoc(albumDocRef, album);
  
  console.log("SAVE DEBUG: updateDoc completed, result:", result);
  return result;
};

export const albumsSearch = (array, keyword) => {
  const searchTerm = keyword.toLowerCase();
  return array.filter((value) => {
    return (
      (value?.title &&
        value.title.toLowerCase().match(new RegExp(searchTerm, "g"))) ||
      (value?.userData && value.userData.userName &&
        value.userData.userName
          .toLowerCase()
          .match(new RegExp(searchTerm, "g"))) ||
      (value?.createdBy &&
        value.createdBy.toLowerCase().match(new RegExp(searchTerm, "g")))
    );
  });
};

export const quickTalesSearch = (array, keyword) => {
  const searchTerm = keyword.toLowerCase();
  return array.filter((value) => {
    return (
      (value.title &&
        value.title.toLowerCase().match(new RegExp(searchTerm, "g"))) ||
      (value.createdBy &&
        value.createdBy.toLowerCase().match(new RegExp(searchTerm, "g")))
    );
  });
};

export const uploadQuickTaleImageToStorage = async (file) => {
  const newFilename = uuidv4();
  const storageRef = ref(storage, `quicktales/images/${newFilename}`);
  await uploadBytes(storageRef, file);
  return await getDownloadURL(storageRef);
};

export const uploadAlbumImageToStorage = async (file) => {
  const newFilename = uuidv4();
  const storageRef = ref(storage, `albums/images/${newFilename}`);
  await uploadBytes(storageRef, file);
  return await getDownloadURL(storageRef);
};

// Groups store images directly under the `groups/` folder in Storage
// (see staging/prod bucket structure)
export const uploadGroupImageToStorage = async (file) => {
  const newFilename = uuidv4();
  const storageRef = ref(storage, `groups/${newFilename}`);
  await uploadBytes(storageRef, file);
  return await getDownloadURL(storageRef);
};

export const uploadQuickTaleAudioToStorage = async (file) => {
  const newFilename = uuidv4();
  const storageRef = ref(storage, `quicktales/audio/${newFilename}`);
  await uploadBytes(storageRef, file);
  return await getDownloadURL(storageRef);
};

export const handleFilterChipClick = (
  index,
  options,
  setOptions,
  setFilterOptions
) => {
  let updatedOptions = [...options]; // Clone the current state to avoid direct mutation
  if (updatedOptions[index].label === "All") {
    // If "All" is selected, update all options to reflect the change
    console.log("all", updatedOptions);
    updatedOptions = updatedOptions.map((option, idx) => ({
      ...option,
      selected: idx === index ? true : false, // Select "All" and deselect others
    }));
    setFilterOptions([]); // Clear all filter options since "All" is selected
  } else {
    // For any option other than "All", update its selected state and ensure "All" is deselected
    updatedOptions[index].selected = !updatedOptions[index].selected;
    updatedOptions[0].selected = false; // Deselect "All"
    let label = updatedOptions[index].label;

    // Update the filter options based on the selected state
    const filterOptionsTemp = updatedOptions.reduce((acc, curr, idx) => {
      if (idx !== 0 && curr.selected) {
        // Skip "All" and include only selected options
        acc.push(curr.label);
      }
      return acc;
    }, []);
    console.log(label, filterOptionsTemp);
    setFilterOptions(filterOptionsTemp);
  }
  setOptions(updatedOptions); // Update the options state with the new changes
};

export const getFilterAlbums = async (
  dateRange,
  statusFilterOptions,
  setLoading,
  handleFilterModalClose,
  organizationId
) => {
  setLoading(true);

  // Create a function to deduplicate documents based on their IDs
  const deduplicate = (arr) => {
    const uniqueIds = new Set();
    const uniqueDocs = [];
    console.log("arr:", arr);
    arr.forEach((doc) => {
      if (!uniqueIds.has(doc.id)) {
        uniqueIds.add(doc.id);
        uniqueDocs.push(doc);
      }
    });
    console.log("results:", uniqueDocs);
    handleFilterModalClose();
    return uniqueDocs;
  };

  try {
    let results = [];

    const statusOptions =
      statusFilterOptions.length > 0 ? statusFilterOptions : [null];

    for (const status of statusOptions) {
      let queries = [];

      if (status !== null) {
        queries.push(where("privacy", "==", status.toLowerCase()));
      }

      if (dateRange && dateRange.startDate && dateRange.endDate) {
        queries.push(where("createdAt", ">=", dateRange.startDate));
        queries.push(where("createdAt", "<=", dateRange.endDate));
      }

      queries.push(where("organization", "==", organizationId));

      if (queries.length > 0) {
        const q = query(AlbumsRef, ...queries);
        const querySnapshot = await getDocs(q);

        const fetchDetailsPromises = querySnapshot.docs.map(async (doc) => {
          const userTemp = await getSingleUser(doc.data().user);
          return {
            id: doc.id,
            ...doc.data(),
            quicktaleData: [],
            userData: userTemp?.data() ? userTemp.data() : {},
          };
        });

        // Wait for all enrichment promises to resolve
        const queryResults = await Promise.all(fetchDetailsPromises);
        results = results.concat(queryResults);
      }
    }

    // Deduplicate the results
    const uniqueResults = deduplicate(results);
    console.log("uniqueResults", uniqueResults);
    handleFilterModalClose();
    return uniqueResults;
  } catch (error) {
    console.error("Error filtering Albums:", error);
    return []; // Return an empty array in case of error
  } finally {
    setLoading(false);
  }
};

// export const getFilterAlbums = async (
//   // whoCanListenFilterOptions,
//   dateRange,
//   statusFilterOptions,
//   setLoading,
//   handleFilterModalClose,
//   organizationId
// ) => {
//   setLoading(true)
//   // Create a function to deduplicate documents based on their IDs
//   const deduplicate = (arr) => {
//     const uniqueIds = new Set();
//     const uniqueDocs = [];
//     console.log("arr:", arr);
//     arr.forEach((doc) => {
//       if (!uniqueIds.has(doc.id)) {
//         uniqueIds.add(doc.id);
//         uniqueDocs.push(doc);
//       }
//     });
//     console.log("results:", uniqueDocs);
//     handleFilterModalClose();
//     return uniqueDocs;
//   };

//   try {

//     let queries = [
//       ...statusFilterOptions.map((option) =>
//         where("privacy", "==", option.toLowerCase())
//       ),
//     ];

//     if (
//       dateRange &&
//       dateRange?.startDate &&
//       dateRange?.endDate
//     ) {
//       queries.push(where("createdAt", ">=", dateRange.startDate));
//       queries.push(where("createdAt", "<=", dateRange.endDate));
//     }
//     if (organizationId) {
//       queries.push(where("organization", "==", organizationId));
//     }

//     const q = query(AlbumsRef, ...queries);
//     const querySnapshot = await getDocs(q);

//     const fetchDetailsPromises = querySnapshot.docs.map(async (doc) => {
//       const userTemp = await getSingleUser(doc.data().user);
//       return {
//         id: doc.id,
//         ...doc.data(),
//         quicktaleData: [],
//         userData: userTemp?.data() ? userTemp.data() : {},
//       };
//     });

//     // Wait for all enrichment promises to resolve
//     const results = await Promise.all(fetchDetailsPromises);
//     // Deduplicate the results
//     const uniqueResults = deduplicate(results);
//     console.log("uniqueResults", uniqueResults);
//     handleFilterModalClose();
//     return uniqueResults;
//   } catch (error) {
//     console.error("Error filtering Albums:", error);
//     return []; // Return an empty array in case of error
//   } finally {
//     setLoading(false);
//   }
// };

export const addAlbum = async (data) => {
  const AlbumsRef = collection(db, "albums");
  return await addDoc(AlbumsRef, data);
};

export const deleteAlbum = async (id) => {
  const albumDocRef = doc(db, "albums", id);
  return await deleteDoc(albumDocRef);
};
